<template>
  <b-card-code title="جدول الوصفات" no-body>
    <b-card-body>
      <div class="d-flex justify-content-between flex-wrap">
        <b-form-group
          label="فلتر"
          label-cols-sm="2"
          label-align-sm="left"
          label-size="sm"
          label-for="filterInput"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              id="filterInput"
              v-model="filter"
              type="search"
              placeholder="ابحث عن .."
            />
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">
                الغاء الفلتر
              </b-button>
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                v-b-modal.model-a-w
              >
                <feather-icon icon="FilePlusIcon" class="mr-50" />
                <span class="align-middle">اضافة وصف جديد</span>
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>
      <b-form-row style="margin-top: 10px">
        <b-col v-show="search.departments.length > 0" md="4">
          <b-form-group>
            <v-select
              v-model="search.department_id"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="ar_name"
              :options="search.departments"
              placeholder="اختر القسم"
            />
          </b-form-group>
        </b-col>
        <b-col v-show="search.years.length > 0" md="4">
          <b-form-group>
            <v-select
              v-model="search.year_id"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="year"
              :options="search.years"
              placeholder="اختر السنة"
            />
          </b-form-group>
        </b-col>
      </b-form-row>
    </b-card-body>
    <div class="demo-vertical-spacing">
      <b-progress v-if="precentage !== 0" :value="precentage" max="100" />
    </div>
    <b-table
      ref="table"
      striped
      hover
      responsive
      class="position-relative"
      :per-page="perPage"
      :items="items"
      :fields="fields"
    >
      <template #cell(action)="action">
        <b-dropdown
          variant="link"
          no-caret
          :right="$store.state.appConfig.isRTL"
        >
          <template #button-content>
            <feather-icon
              icon="MoreVerticalIcon"
              size="16"
              class="align-middle text-body"
            />
          </template>
          <b-col md="6">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-warning"
              v-b-modal.model-e-w
              @click="eRM(action.item)"
            >
              <feather-icon icon="EditIcon" class="mr-50" />
              <span class="align-middle"></span>
            </b-button>
          </b-col>
          <b-col md="6">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-danger"
              v-b-modal.modal-center
              @click="dRM(action.item)"
            >
              <feather-icon icon="Trash2Icon" class="mr-50" />
              <span class="align-middle"></span>
            </b-button>
          </b-col>
        </b-dropdown>
      </template>
      <template #cell(ar)="data">
        <a :href="getImage(data.item.ar)" target="_blank" class="btn btn-sm btn-outline-primary">عرض</a>
      </template>
      <template #cell(en)="data">
        <a :href="getImage(data.item.en)" target="_blank" class="btn btn-sm btn-outline-primary">عرض</a>
      </template>
      <template #cell(year)="data">
        {{ `${data.item.year.begin} - ${data.item.year.end}` }}
      </template>
    </b-table>

    <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
      <b-form-group
        label="Per Page"
        label-cols="6"
        label-align="left"
        label-size="sm"
        label-for="sortBySelect"
        class="text-nowrap mb-md-0 mr-1"
      >
        <b-form-select
          id="perPageSelect"
          v-model="perPage"
          @change="check()"
          size="sm"
          inline
          :options="pageOptions"
        />
      </b-form-group>

      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        first-number
        last-number
        prev-class="prev-item"
        next-class="next-item"
        class="mb-0"
        @change="check()"
      >
        <template #prev-text>
          <feather-icon icon="ChevronLeftIcon" size="18" />
        </template>
        <template #next-text>
          <feather-icon icon="ChevronRightIcon" size="18" />
        </template>
      </b-pagination>
    </b-card-body>
    <b-modal
      id="model-e-w"
      ok-title="حفظ البيانات"
      centered
      size="lg"
      title="تعديل الوصف"
      @show="checkModel"
      @hidden="rEF"
      @ok="uM"
    >
      <b-form novalidate class="needs-validation">
        <b-form-row>
          <b-col v-if="departments.length > 0" md="12">
            <b-form-group>
              <label for="basic-password">القسم</label>
              <v-select
                v-model="editform.department_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="ar_name"
                :options="departments"
                placeholder="اختر القسم"
              />
            </b-form-group>
          </b-col>
          <b-col v-if="years.length > 0" md="12">
            <b-form-group>
              <label for="basic-password">السنة</label>
              <v-select
                v-model="editform.year_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="year"
                :options="years"
                placeholder="اختر السنة"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <label for="input-valid1">ملف الوصف العربي:</label>
            <b-form-file
              placeholder="اختر الملف او اسقطها هنا..."
              drop-placeholder="اختر الملف او اسقطها هنا..."
              v-model="editform.ar_file"
              @change="selectArFile"
            />
          </b-col>
          <b-col md="12">
            <label for="input-valid1">ملف الوصف الانكليزي:</label>
            <b-form-file
              placeholder="اختر الملف او اسقطها هنا..."
              drop-placeholder="اختر الملف او اسقطها هنا..."
              v-model="editform.en_file"
              @change="selectEnFile"
            />
          </b-col>
        </b-form-row>
      </b-form>
    </b-modal>
    <b-modal
      id="model-e-e"
      ok-title="Accept"
      centered
      size="lg"
      title="Edit Employees"
      @ok="uE"
      @hidden="rEF"
    >
      <b-form novalidate class="needs-validation" style="margin-bottom: 280px">
        <b-form-row>
          <b-col md="12">
            <label for="input-valid1">employees:</label>
            <v-select
            v-model="edit.employees"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            multiple
            label="title"
            :options="employees"
          />
          </b-col>
        </b-form-row>
      </b-form>
    </b-modal>
    <b-modal
      id="model-a-w"
      ok-title="حفظ البيانات"
      centered
      size="lg"
      title="اضافة وصف جديد"
      @show="checkModel"
      @ok="aNM"
      @hidden="rF"
    >
      <b-form novalidate class="needs-validation">
        <b-form-row>
          <b-col v-if="departments.length > 0" md="12">
            <b-form-group>
              <label for="basic-password">اختر القسم</label>
              <v-select
                v-model="form.department_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="ar_name"
                :options="departments"
                placeholder="اختر القسم"
              />
            </b-form-group>
          </b-col>
          <b-col v-if="years.length > 0" md="12">
            <b-form-group>
              <label for="basic-password">اختر السنة</label>
              <v-select
                v-model="form.year_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="year"
                :options="years"
                placeholder="اختر السنة"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <label for="input-valid1">ملف الوصف العربي:</label>
            <b-form-file
              placeholder="اختر الملف او اسقطها هنا..."
              drop-placeholder="اختر الملف او اسقطها هنا..."
              ref="arFile"
              v-model="form.ar_file"
              @change="selectArFiles"
            />
          </b-col>
          <b-col md="12">
            <label for="input-valid1">ملف الوصف الانكليزي:</label>
            <b-form-file
              placeholder="اختر الملف او اسقطها هنا..."
              drop-placeholder="اختر الملف او اسقطها هنا..."
              ref="enFile"
              v-model="form.en_file"
              @change="selectEnFiles"
            />
          </b-col>
        </b-form-row>
      </b-form>
    </b-modal>

    <b-modal
      id="modal-center"
      centered
      title="Delete User"
      @ok="dM"
      ok-title="Accept"
    >
      <b-card-text>
        do you really want to delete this description "{{ this.editform.ar }}" ?
      </b-card-text>
    </b-modal>
  </b-card-code>
</template>

<script>
import vSelect from "vue-select";
import store from "@/store";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import BCardCode from "@core/components/b-card-code/BCardCode.vue";
import {
  BTable,
  BAvatar,
  BModal,
  BDropdown,
  BDropdownItem,
  BFormCheckboxGroup,
  BForm,
  BFormRow,
  BCol,
  VBModal,
  BProgress,
  BBadge,
  BFormValidFeedback,
  BFormInvalidFeedback,
  BFormGroup,
  BFormCheckbox,
  BCardText,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCardBody,
  BFormFile,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { integer } from "vee-validate/dist/rules";
import { filesUrl } from "@/main.js";

export default {
  components: {
    BCardCode,
    BTable,
    BForm,
    BFormFile,
    vSelect,
    filesUrl,
    BAvatar,
    BBadge,
    BFormRow,
    BDropdown,
    BDropdownItem,
    BFormGroup,
    togglePasswordVisibility,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormCheckboxGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BModal,
    VBModal,
    Ripple,
    BProgress,
    BCol,
    BFormCheckbox,
    BCardText,
    BFormValidFeedback,
    BFormInvalidFeedback,
  },
  data() {
    return {
      precentage: 0,
      teacher_id: "",
      perPage: 3,
      pageOptions: [3, 5, 10, 100],
      totalRows: 1,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      department: "",
      title: "",
      employees: [],
      edit: {
        employees: [],
        department_id: null,
        count:0
      },
      search: {
        departments: [],
        department_id: "",
        years: [],
        year_id: "",
      },
      filter: null,
      types: [],
      years: [],
      filterOn: [],
      coordinator_id: "",
      manager_id: "",
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      lecture_id: "",
      departments: [],
      fields: [
        {
          key: "ar",
          label: "الوصف العربي",
        },
        {
          key: "en",
          label: "الوصف الانكليزي",
        },
        {
          key: "department.ar_name",
          label: "القسم",
        },
        {
          key: "year",
          label: "السنة",
        },
        { key: "action", label: "الاجراءات" },
      ],
      items: [],
      form: {
        ar_file: "",
        en_file: "",
        department_id: null,
        year_id: null,
      },
      editform: {
        ar_file: "",
        en_file: "",
        department_id: "",
        year_id: "",
        id: null,
      },
      teachers: [],
    };
  },
  mixins: [togglePasswordVisibility],
  computed: {
    sortOptions() {
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
  },
  directives: {
    Ripple,
  },
  mounted() {
    this.ID(), this.gR(), this.gDepartments(), this.gYears();
    this.totalRows = this.items.length;
  },
  watch: {
    "search.department_id": function (val) {
      this.gR();
    },
    "search.year_id": function (val) {
      this.gR();
    },
  },
  methods: {
    async gDepartments() {
      this.departments = [];
      await this.axios.get(`since/deparment?take=100&skip=0`).then((res) => {
        this.departments = res.data.items;
        this.search.departments = res.data.items;
      });
    },
    async gYears() {
      this.years = [];
      await this.axios.get(`years`).then((res) => {
        this.years = res.data.items;
        this.search.years = res.data.items;
      });
    },
    checkModel() {
      this.selected = [];
      if (this.editform.is_sustainabilty == 1) {
        this.selected.push("is_sustainabilty");
      }
      if (this.editform.is_energy == 1) {
        this.selected.push("is_energy");
      }
    },
    async uE() {
      this.edit.count = this.edit.employees.length
      await this.axios
        .post(`employees/${this.edit.id}`, this.edit,{
          onUploadProgress: progressEvent => {
            this.precentage =
              (progressEvent.loaded / progressEvent.total) * 100;
          }
        })
        .then((res) => {
          if (res.data.errors) {
            this.errorToast();
          } else {
            this.gR();
            this.makeToast(
              "success",
              "update Success",
              "Your update is done successfully"
            );
          }
          this.precentage=0
        })
        .catch((e) => {
          if (e.message.includes("401")) {
            this.makeToast(
              "warning",
              "update failed",
              "you don't a permision to do this action ;)"
            );
          } else {
            this.errorToast();
          }
        });
    },
    async uM() {
      let data = new FormData();
      data.append("department_id", this.editform.department_id.id);
      data.append("year_id", this.editform.year_id.id);
      if (this.editform.ar_file != "undefined" && this.editform.ar_file != "") {
        data.append("ar", this.editform.ar_file);
      }
      if (this.editform.en_file != "undefined" && this.editform.en_file != "") {
        data.append("en", this.editform.en_file);
      }
      await this.axios
        .post(`descriptions/${this.editform.id}`, data, {
          onUploadProgress: (progressEvent) => {
            this.precentage =
              (progressEvent.loaded / progressEvent.total) * 100;
          },
        })
        .then((res) => {
          if (res.data.errors) {
            this.errorToast();
          } else {
            this.gR();
            this.makeToast(
              "success",
              "update Success",
              "Your update is done successfully"
            );
          }
          this.precentage = 0;
        })
        .catch((e) => {
          if (e.message.includes("401")) {
            this.makeToast(
              "warning",
              "update failed",
              "you don't a permision to do this action ;)"
            );
          } else {
            this.errorToast();
          }
        });
      this.rEF();
    },
    async aNM() {
      let data = new FormData();
      data.append("department_id", this.form.department_id.id);
      data.append("year_id", this.form.year_id.id);
      if (this.form.ar_file != "undefined" && this.form.ar_file != "") {
        data.append("ar", this.form.ar_file);
      }
      if (this.form.en_file != "undefined" && this.form.en_file != "") {
        data.append("en", this.form.en_file);
      }
      await this.axios
        .post(`descibations`, data, {
          onUploadProgress: (progressEvent) => {
            this.precentage =
              (progressEvent.loaded / progressEvent.total) * 100;
          },
        })
        .then((res) => {
          if (res.data.errors) {
            this.errorToast();
          } else {
            this.gR();
            this.makeToast(
              "success",
              "update Success",
              "Your update is done successfully"
            );
          }
          this.precentage = 0;
        })
        .catch((e) => {
          if (e.message.includes("401")) {
            this.makeToast(
              "warning",
              "update failed",
              "you don't a permision to do this action ;)"
            );
          } else {
            this.errorToast();
          }
        });
      this.rF();
    },
    rF() {
      this.form.ar_file = "";
      this.form.en_file = "";
      this.form.department_id = "";
      this.form.year_id = "";
    },
    rEF() {
      this.editform.ar_file = "";
      this.editform.en_file = "";
      this.editform.department_id = "";
      this.editform.year_id = "";
      this.editform.id = null;
    },
    async dM() {
      await this.axios
        .delete(`descriptions/${this.editform.id}`)
        .then((res) => {
          if (res.data.errors) {
            this.errorToast();
          } else {
            this.gR();
            this.makeToast(
              "success",
              "Delete Success",
              "Your item is deleted successfully"
            );
          }
        })
        .catch((e) => {
          if (e.message.includes("401")) {
            this.makeToast(
              "warning",
              "update failed",
              "you don't a permision to do this action ;)"
            );
          } else {
            this.errorToast();
          }
        });
    },
    errorToast() {
      this.makeToast(
        "danger",
        "update failed",
        "some thing want wrong, i`m sorry :("
      );
    },
    eRM(item) {
      this.editform.ar_file = item.ar;
      this.editform.en_file = item.en;
      this.editform.department_id = item.department;
      this.editform.year_id = item.year;
      this.editform.id = item.id;
    },

    dRM(item) {
      this.editform.ar = item.ar;
      this.editform.id = item.id;
    },
    check() {
      setTimeout(() => this.gR(), 1000);
    },
    ID() {
      this.teacher_id = localStorage.getItem("NisourTeacherId");
    },
    async gR() {
      await this.axios
        .get(
          `descibations?take=${this.perPage}&skip=${
            (this.currentPage - 1) * this.perPage
          }&department_id=${this.search.department_id ? this.search.department_id.id : ''}&year_id=${this.search.year_id ? this.search.year_id.id : ''}`
        )
        .then((res) => {
          console.log(res);
          this.items = [];
          this.totalRows = res.data.totalCount;
          this.items = res.data.items;
        })
        .catch((e) => {
          if (e.message.includes("401")) {
            this.makeToast(
              "danger",
              "update failed",
              "you don't a permision to do this action ;)"
            );
          } else {
            this.errorToast();
          }
        });
    },
    makeToast(variant = null, title = null, body = null) {
      this.$bvToast.toast(body, {
        title: title,
        variant,
        solid: false,
      });
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    selectArFiles(e) {
      this.form.ar_file = "";
      this.form.ar_file = e.target.files[0];
    },
    selectEnFiles(e) {
      this.form.en_file = "";
      this.form.en_file = e.target.files[0];
    },
    selectArFile(e) {
      this.editform.ar_file = "";
      this.editform.ar_file = e.target.files[0];
    },
    selectEnFile(e) {
      this.editform.en_file = "";
      this.editform.en_file = e.target.files[0];
    },
    getImage(path) {
        if (path.includes("http://127.0.0.1:8000")||path.includes("https://e-learn.nuc.edu.iq")) {
          return path;
        }
      return `${filesUrl}/${path}`;
    },
  },
};
</script>
